<template>
  <div class="onboarding-status" v-if="hasIncompleteSteps">
    <StepsList :home-mode="true" :compact-mode="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createStepsArray } from '@/views/launch/config/stepsConfig.js';
import StepsList from '@/views/launch/components/StepsList.vue';

export default {
  name: 'HomeOnboardingStatus',
  components: {
    StepsList,
  },
  computed: {
    ...mapGetters('users', [
      'hasAchievement',
      'achievementsLoaded',
      'currentUser',
    ]),
    ...mapGetters('programs', {
      getProgram: 'getProgram',
      programsLoaded: 'loaded',
    }),

    isSMSEnabled() {
      const program = this.getProgram('productsSms');
      if (!this.programsLoaded || !program) return true;
      return program?.enabled;
    },

    isUserActivated() {
      return this.currentUser?.activated || false;
    },

    isDataReady() {
      return this.achievementsLoaded && this.programsLoaded;
    },

    incompleteStepsCount() {
      if (!this.isDataReady) return 0;

      const steps = createStepsArray(
        this.isSMSEnabled,
        true,
        this.isUserActivated
      );
      const incompleteSteps = steps.filter(
        (step) =>
          !step.completed &&
          step.id !== 'finish' &&
          (!step.event || !this.hasAchievement(step.event))
      );

      return incompleteSteps.length;
    },

    hasIncompleteSteps() {
      if (!this.currentUser?.owner) return false;
      return this.incompleteStepsCount > 0;
    },
  },
};
</script>
